import { fetchWithAuth } from './fetchWithAuth'

export async function createInventorySystemProfile(
  token: string,
  body: Record<string, unknown>,
): Promise<void> {
  await fetchWithAuth('/v1/inventory-system-profiles', token, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}
